import React, { useEffect, useState } from "react";
import CustomTypography from "../../components/CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import { useStyles } from "../../assets/jss/Admin";
import SearchBar from "../../components/SearchBar/SearchBar";
import AdminCard from "../../components/AdminCard/AdminCard";
import userIcon from "../../assets/images/addUser.svg";
import groupIcon from "../../assets/images/addGroup.svg";
import reportedEventIcon from "../../assets/images/errorIcon.svg";
import hirarchyIcon from "../../assets/images/hierarchyIcon.svg";
import CustomBox from "../../components/CustomComponents/CustomBox/CustomBox";
import { getGroupList, getHierarchyGroupList, getMileageClaimsEnabled, getSession, getUserRBAC } from "../../services/LocalStorageService";
import { EntityAccess, RBAC_CODE } from "../../config/app-globals.enum";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
export default function Admin(props: any) {
    const { t } = useTranslation();
    const classes = useStyles();
    const params = useParams();
    const [getRBAC_AdminUserCreateView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_USER_CREATE_VIEW, props)
    );
    const [getRBAC_AdminSearchBarView] = React.useState(
        getUserRBAC(RBAC_CODE.ADMIN_SEARCH_BAR_VIEW, props)
    );

    const [loggedInUserSession] = useState(getSession);
    const [groupData, setGroupData] = useState(null);
    const [isGroupAllowed, setIsGroupAllowed] = useState(false);

    useEffect(() => {
        async function getGroupData() {
            var data = await getGroupList("");
            setGroupData(data);
        }
        getGroupData();
    }, []);

    function findObject(obj, id) {
        const result = findObjectAux([obj], id);
        return result;
    }
    function findObjectAux(arr, id) {
        if (arr !== undefined && arr !== null) {
            for (const obj of arr) {
                if (obj.id === id) return obj;
                const nestedObj = findObjectAux(obj.childGroups, id);
                if (nestedObj) return nestedObj;
            }
        }
    }

    useEffect(() => {
        async function checkGroupAllowed() {
            const data = await getHierarchyGroupList(params, loggedInUserSession.currentGroupId);
            let obj = data.content;
            const result = findObject(obj, loggedInUserSession.currentGroupId);
            if (result) {
                if (result.isAllowChangesInGroup === 0) {
                    setIsGroupAllowed(true);
                }
            }
        }
        checkGroupAllowed();
    }, [groupData]);

    const [cardData, setCardData] = useState([
        {
            id: 1,
            title: t("ADD_NEW_USER"),
            isEnabled: true,
            link: "/admin/users",
            description: t("YOU_CAN_ADD_A_NEW_USER_TO_YOUR_PRISO_ACCOUNT"),
            icon: userIcon,
            entityCode: "ADMIN_USER_CREATE_VIEW",
            entityAccess: false,
        },
        {
            id: 2,
            title: t("ADD_NEW_GROUP"),
            isEnabled: true,
            link: "/admin/groups/add",
            description: t("CREATE_NEW_GROUP_WITHIN_YOUR_HIERARCHY"),
            icon: groupIcon,
            entityCode: "ADMIN_GROUP_CREATE_VIEW",
            entityAccess: false,
        },
        {
            id: 3,
            title: t("REPORTED_EVENTS"),
            isEnabled: true,
            link: "/admin/reported-events",
            description: t("VIEW_REPORTED_EVENT_AND_APPROVE"),
            icon: reportedEventIcon,
            entityCode: "",
            entityAccess: true,
        },
        {
            id: 4,
            title: t("MILEAGE_CLAIMS"),
            isEnabled: getMileageClaimsEnabled(),
            link: "/admin/mileage-claims",
            description: t("VIEW_MILEAGE_CLAIMS_AND_APPROVE"),
            icon: hirarchyIcon,
            entityCode: "",
            entityAccess: true,
        },
        {
            id: 5,
            title: t("VIEW_HIERARCHY"),
            isEnabled: false,
            link: "/admin",
            description: t("COMING_SOON"),
            icon: hirarchyIcon,
            entityCode: "",
            entityAccess: false,
        },
    ]);



    useEffect(() => {
        if (
            getRBAC_AdminUserCreateView &&
            getRBAC_AdminUserCreateView.isGroupScope === EntityAccess.ALLOWED &&
            getRBAC_AdminUserCreateView.isAccessible === EntityAccess.ALLOWED
        ) {
            let _cardData = [...cardData];
            if (_cardData && _cardData.length) {
                const userCardIndex = _cardData.findIndex(
                    (d) => d.entityCode === RBAC_CODE.ADMIN_USER_CREATE_VIEW
                );
                if (userCardIndex >= 0) {
                    _cardData[userCardIndex].entityAccess = true;
                }
            }
            setCardData([..._cardData]);
        }
    }, [getRBAC_AdminUserCreateView]);
    return (
        <>
            <CustomBox className={classes.adminLayoutWrapper}>
                {getRBAC_AdminSearchBarView &&
                    getRBAC_AdminSearchBarView.isAccessible === EntityAccess.ALLOWED ? (
                    <>
                        <CustomGrid container spacing={0} justifyContent="center">
                            <CustomGrid item xs={12} lg={8}>
                                <CustomTypography
                                    component="h1"
                                    variant="h5"
                                    className={classes.headingTitle}
                                >
                                    {t("FIND_WHAT_YOU_NEED")}
                                </CustomTypography>
                            </CustomGrid>
                        </CustomGrid>
                        <CustomGrid container spacing={8} justifyContent="center">
                            <CustomGrid item xs={12} lg={8} md={8}>
                                <SearchBar />
                            </CustomGrid>
                        </CustomGrid>
                    </>
                ) : null}
                <CustomGrid
                    container
                    spacing={4}
                    justifyContent="center"
                    className={classes.adminCardWrapper}
                >
                    <CustomGrid item sm={8}>
                        <CustomGrid container spacing={3}>
                            {cardData && cardData.length
                                ? cardData.map((item, index) => {
                                    return item.entityAccess || (item.title === t("ADD_NEW_GROUP") && isGroupAllowed) ? (
                                        // return item.entityAccess ? (
                                        <CustomGrid
                                            item
                                            xs={12}
                                            md={6}
                                            lg={3}
                                            key={`${index}-adminCard-${item.id}`}
                                        >
                                            <AdminCard data={item} />
                                        </CustomGrid>
                                    ) : null;
                                })
                                : null}
                        </CustomGrid>
                    </CustomGrid>
                </CustomGrid>
            </CustomBox>
        </>
    );
}

